import { createAction, createSlice } from "@reduxjs/toolkit";
import { editingCourseActions } from "./editingCourse";

const addLectureSlice = createSlice({
  name: "addLecture",
  initialState: {
    data: null,
    processingList: [{ id: null, processing: false, isSuccess: null }],
  },
  reducers: {
    pending(state, action) {
      const { lectureId } = action.payload;
      state.processingList.push({
        id: lectureId,
        processing: true,
      });
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { lectureId } = action.payload;
      const lectureIndex = state.processingList.findIndex(
        (lecture) => lecture.id == lectureId
      );
      state.processingList[lectureIndex].processing = false;
      state.processingList[lectureIndex].isSuccess = true;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      const { lectureId } = action.payload;
      const lectureIndex = state.processingList.findIndex(
        (lecture) => lecture.id == lectureId
      );
      state.processingList[lectureIndex].processing = false;
      state.processingList[lectureIndex].isSuccess = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = addLectureSlice;
const addLectureAction = editingCourseActions.addLecture;

export {
  addLectureAction,
  actions as addLectureActions,
  reducer as addLectureReducer,
};
